module.exports = __webpack_public_path__ + "static/media/scroll.c0bd2b96.svg";